import { AIModelKind } from 'shared/entities/smartbotAI';
import { AITariffication } from 'shared/entities/tariffication';

export class AITarifficationModel {
  private readonly tariffication: AITariffication;

  constructor({ tariffication }: { tariffication: AITariffication }) {
    this.tariffication = tariffication;
  }

  getAIModelPrice = (modelKind: AIModelKind): number | null => {
    return this.tariffication?.[modelKind] ?? null;
  };

  static fromJson(raw: AITariffication) {
    return new AITarifficationModel({ tariffication: raw });
  }
}
